import React from 'react';
import { Button, Container, Form, InputGroup } from 'react-bootstrap';
import ContentBlockSmall from '../Components/ContentBlockSmall';
import LoginService from '../Api/LoginService';
import { setToken, setUser } from '../Session/Session';
import { withRouter } from '../Components/WithRouter';

class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            PageTitle: 'Prisijungimas',
            Email: '',
            Password: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.processLogin = this.processLogin.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
    }

    processLogin = (event) => {
        event.preventDefault();
        const email = this.state.Email;
        const password = this.state.Password;

        LoginService.login(email, password).then((response) => {
            setToken(response.data.token);
            this.getUserInfo(response.data.token);
            this.props.navigate('/kursai');
        });
    }

    getUserInfo = (token) => {
        LoginService.getUserInfo(token).then((response) => {
            setUser(response.data);
        });
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(kursai-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };



        return (
            <Container fluid style={pageStyle}>
                <Container style={{ paddingTop: '20vh' }}>
                    <div className="row">
                        <div className="col-12 col-md-6 offset-md-3">
                            <ContentBlockSmall>
                                <h1>{this.state.PageTitle}</h1>
                                <Form>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            type="text"
                                            placeholder="Įveskite vartotojo vardą"
                                            aria-label="Įveskite vartotojo vardą"
                                            aria-describedby="basic-addon2"
                                            name="Email"
                                            onChange={this.handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            type="password"
                                            placeholder="Įveskite slaptažodį"
                                            aria-label="Įveskite slaptažodį"
                                            aria-describedby="basic-addon2"
                                            name="Password"
                                            onChange={this.handleInputChange}
                                        />
                                    </InputGroup>
                                    <div className="form-group form-check mt-2">
                                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                        <label className="form-check-label" htmlFor="exampleCheck1">Prisiminti mane</label>
                                    </div>
                                    <Button variant='outline-light' onClick={this.processLogin}>Prisijungti</Button>
                                </Form>

                                <Button variant="outline-light" className="mt-2" href="/registracija">Registruotis</Button>
                            </ContentBlockSmall>
                        </div>
                    </div>
                </Container>
            </Container>
        );
    }
}

export default withRouter(LoginPage);